import React from 'react';
import { Menu, notification } from 'antd';
import { reduxForm, Field, isDirty } from 'redux-form';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { compose, bindActionCreators } from 'redux';
import { customInput } from '../../../common/custom-input';
import { Strings } from '../../../../dataProvider/localize';
import { CustomDatepicker } from '../../../common/customDatepicker';
import moment from 'moment';
// import { IconButton } from "@mui/material";
import { CustomSingleSelect } from "../../../common/new-core-ui/CustomSingleSelect";
import { ADMIN_DETAILS, VALIDATE_STATUS, ACCESS_CONTROL } from '../../../../dataProvider/constant';
import { isNumber } from '../../../../utils/Validations/scopeDocValidation';
import { countryCodes } from '../../../../dataProvider/countryCodes'
import { handleFocus, DeepTrim } from '../../../../utils/common';
import * as actions from '../../../../actions/profileManagementActions';
import { Link } from 'react-router-dom';
import { getStorage, setStorage } from '../../../../utils/common';
import { personalDetailsForm } from '../../../../utils/Validations/personalDetailsFormValidation';
// import { createCanvas, loadImage } from 'canvas';
import colourStyles from "../FilterSelectProfileStyles";
import { components } from "react-select";
import PhoneDropdownStyle from "../PhoneDropdownStyles";
import "../ProfileStyle.css";
import styles from "../ProfileStyles.module.css";
// import ManagerDetails from "../ManagerDetails/ManagerDetails";
// import {
//     loadModels,
//     getFullFaceDescription,
// } from '../../../../dataProvider/face';
// import UserTimeZone from '../UserTimeZone/UserTimeZone';

const INIT_STATE = {
    url: null,
    imageURL: null,
    fullDesc: null,
    imageDimension: null,
    error: null,
    loading: false
};

class PesonalDetailsForm extends React.Component {
    gender = ['Male', 'Female', 'Other']

    constructor(props) {
        super(props);
        this.state = {
            date: '',
            phnOtpErr: false,
            emailOtpErr: false,
            fileList: [],
            fileRemoved: false,
            hasEditPermission: false
        }

        this.org_user_id = JSON.parse(getStorage(ADMIN_DETAILS)) ? JSON.parse(getStorage(ADMIN_DETAILS)).organisation.id : null;
        this.org_user_name = JSON.parse(getStorage(ADMIN_DETAILS)) ? JSON.parse(getStorage(ADMIN_DETAILS)).user_name : null;
        this.shouldUpdateAuthUser = this.props.isFromUserManagement && this.props.isFromUserManagement === 'isFromUserMgmt' ? true : false
    }

    static getDerivedStateFromProps(props, state) {
        var OrgSACountry = JSON.parse(getStorage(ADMIN_DETAILS)) ? JSON.parse(getStorage(ADMIN_DETAILS)).country : null;
        if (!props.formValues && props.formValues.ec_country || props.formValues && props.formValues.ec_country === '') {
            props.change(`ec_country`, OrgSACountry);
        }
    }

    componentDidMount() {
        if (this.hasPermission("sf_personal_details_controller_update_personal_details")) {
            this.setState({ hasEditPermission: true });
        }
    }

    onSubmit = async (formData) => {
        formData = await DeepTrim(formData);
        formData = {
            ...formData,
            'profile_progress': this.props.profileComplete,
            country_code: formData.country_code && formData.country_code.value ? formData.country_code.value : null,
            gender: formData.gender && formData.gender.value ? formData.gender.value : null,
            date_of_birth: formData.date_of_birth ? moment(formData.date_of_birth).format("YYYY-MM-DD") : null,
        }
        delete formData.isDirty

        let finalFormData = new FormData();
        Object.keys(formData).forEach(key => {
            if (key === 'student_usi') {
                if (formData[key]) {
                    finalFormData.append(key, formData[key]);
                }
            } else if (key === 'zone') {
                if (formData[key]) {
                    finalFormData.append(key, formData[key]);
                }
            }
            else {
                finalFormData.append(key, formData[key]);
            }
        });
        finalFormData.delete('profile_pic')
        let staffUserName = false
        if (this.props.userDetails) {
            staffUserName = this.props.userDetails.user_name
        }
        this.props.action.updateOrgUserPersonalDetails(finalFormData, staffUserName)
            .then((flag) => {
                notification.success({
                    message: Strings.success_title,
                    description: flag,
                    onClick: () => { },
                    className: 'ant-success'
                });
                this.props.action.getOrgUserProfileDetails(staffUserName ? this.props.userDetails.user_id : this.org_user_id, staffUserName ? this.props.userDetails.user_name : this.org_user_name, null, this.shouldUpdateAuthUser)
                    .then(() => {
                        this.setState({
                            fileRemoved: false
                        })
                        if (staffUserName) {
                            return
                        } else {
                            setStorage(ADMIN_DETAILS, JSON.stringify({
                                ...JSON.parse(getStorage(ADMIN_DETAILS)),
                                name: this.props && this.props.profile && this.props.profile[0] && this.props.profile[0].name ?
                                    this.props.profile[0].name : JSON.parse(getStorage(ADMIN_DETAILS)).name,
                                last_name: this.props && this.props.profile && this.props.profile[0] && this.props.profile[0].last_name ?
                                    this.props.profile[0].last_name : JSON.parse(getStorage(ADMIN_DETAILS)).last_name
                            }))
                        };
                    });
            })
            .catch((error) => {
                if (error.status === VALIDATE_STATUS) {
                    notification.warning({
                        message: Strings.validate_title,
                        description: error && error.data && typeof error.data.message == 'string'
                            ? error.data.message : Strings.generic_validate,
                        onClick: () => { },
                        className: 'ant-warning'
                    });
                } else {
                    notification.error({
                        message: Strings.error_title,
                        description: error && error.data && error.data.message && typeof error.data.message == 'string'
                            ? error.data.message : Strings.generic_error,
                        onClick: () => { },
                        className: 'ant-error'
                    });
                }
            });
    }

    handleVerifyPhn = () => {
        const phnCode = this.props.formValues.phone_code
        if (phnCode) {
            this.props.action.verifyAttr({ phone_code: phnCode })
                .then(message => {
                    this.setState({
                        phnVerify: 'none'
                    })
                    notification.success({
                        message: Strings.success_title,
                        description: message ? message : Strings.generic_error, onClick: () => { },
                        className: 'ant-success'
                    })
                    this.props.action.getOrgUserProfileDetails(this.org_user_id, this.org_user_namenull, this.shouldUpdateAuthUser);
                }).catch((error) => {
                    if (error.status === VALIDATE_STATUS) {
                        notification.warning({
                            message: Strings.validate_title,
                            description: error && error.data && typeof error.data.message == 'string'
                                ? error.data.message : Strings.generic_validate, onClick: () => { },
                            className: 'ant-warning'
                        });
                    } else {
                        notification.error({
                            message: Strings.error_title,
                            description: error && error.data && error.data.message && typeof error.data.message == 'string'
                                ? error.data.message : Strings.generic_error, onClick: () => { },
                            className: 'ant-error'
                        });
                    }
                });
        } else {
            this.setState({
                phnOtpErr: true
            })
        }
    }

    handleVerifyEmail = () => {
        const emailCode = this.props.formValues.email_code
        if (emailCode) {
            this.props.action.verifyAttr({ email_code: emailCode })
                .then(message => {
                    this.setState({
                        emailVerify: 'none'
                    })
                    notification.success({
                        message: Strings.success_title,
                        description: message ? message : Strings.generic_error, onClick: () => { },
                        className: 'ant-success'
                    })
                    this.props.action.getOrgUserDetails(this.org_user_id, this.org_user_name, null, this.shouldUpdateAuthUser);
                }).catch((error) => {
                    if (error.status === VALIDATE_STATUS) {
                        notification.warning({
                            message: Strings.validate_title,
                            description: error && error.data && typeof error.data.message == 'string'
                                ? error.data.message : Strings.generic_validate, onClick: () => { },
                            className: 'ant-warning'
                        });
                    } else {
                        notification.error({
                            message: Strings.error_title,
                            description: error && error.data && error.data.message && typeof error.data.message == 'string'
                                ? error.data.message : Strings.generic_error, onClick: () => { },
                            className: 'ant-error'
                        });
                    }
                });
        } else {
            this.setState({
                emailOtpErr: true
            })
        }
    }

    resendOtpPhn = val => {
        this.props.action.resendVerifyAttr(val)
            .then(message => {
                notification.success({
                    message: Strings.success_title,
                    description: message ? message : Strings.generic_error,
                    onClick: () => { },
                    className: 'ant-success'
                })
            }).catch(message => {
                notification.error({
                    message: Strings.error_title,
                    description: message ? message : Strings.generic_error,
                    onClick: () => { },
                    className: 'ant-error'
                })
            })
    }

    resendOtpEmail = val => {
        this.props.action.resendVerifyAttr(val)
            .then(message => {
                notification.success({
                    message: Strings.success_title,
                    description: message ? message : Strings.generic_error,
                    onClick: () => { },
                    className: 'ant-success'
                })
            }).catch(message => {
                notification.error({
                    message: Strings.error_title,
                    description: message ? message : Strings.generic_error,
                    onClick: () => { },
                    className: 'ant-error'
                })
            })
    }

    disabledDate = (current) => {
        return current && current.valueOf() > Date.now();
    }

    resetState = () => {
        this.setState({ ...INIT_STATE });
    };


    hasPermission = (permission) => {
        let allowed = false;
        let userPermissions = JSON.parse(getStorage(ACCESS_CONTROL))["userManagement"]
        let accessControl = userPermissions && userPermissions.permissions ? userPermissions.permissions : [];
        let permission_id = accessControl.findIndex(acess => acess.control_name.toLowerCase() === permission.toLowerCase());
        if (permission_id !== -1 || this.props.location.pathname === "/dashboard/profile") {
            allowed = true;
        }
        return allowed;
    }

    DropdownIndicator = props => {
        return (
            <components.DropdownIndicator {...props}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={20} width={20} fill="currentColor">
                    <path d="M201.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 338.7 54.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                </svg>
            </components.DropdownIndicator>
        );
    };

    render() {

        const { handleSubmit, initialValues } = this.props;
        let visa_doc_file_path;
        if (initialValues && initialValues.visa_doc && this.state.fileRemoved) {
            visa_doc_file_path = null;
        } else {
            visa_doc_file_path = initialValues && initialValues.visa_doc ? initialValues.visa_doc : null
        }

        let roleSlug = getStorage(ADMIN_DETAILS) && JSON.parse(getStorage(ADMIN_DETAILS)).role.slug;


        return (
            <form onSubmit={handleSubmit(this.onSubmit)}>
                {/* Personal Details */}
                <hr className={styles.DetailsDivider} />
                <div className="container-fluid">
                    {/* <UserTimeZone
                        userDetails={this.props.userDetails}
                        onReloadUser={() => this.props.action.getOrgUserDetails(this.props.userDetails ? this.props.userDetails.organisation_id : this.org_user_id, this.props.userDetails ? this.props.userDetails.user_name : this.org_user_name, null, this.shouldUpdateAuthUser)} />
                    <ManagerDetails
                        userDetails={this.props.userDetails}
                        onClose={() => this.props.action.getOrgUserProfileDetails(this.props.userDetails ? this.props.userDetails.organisation_id : this.org_user_id, this.props.userDetails ? this.props.userDetails.user_name : this.org_user_name, null, this.shouldUpdateAuthUser)}/> */}
                    <div className="row align-items-center">
                        <h2 className={`${styles.ProfileLabel} font-weight-bold`}>Personal Details</h2>
                    </div>
                    <div className="row">
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>First Name</div>
                            <div>
                                <Field
                                    name="name"
                                    placeholder={Strings.name_acc_pd}
                                    type="text"
                                    id="name"
                                    className={styles.ProfileFormField}
                                    autoComplete="off"
                                    component={customInput}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>Middle Name</div>
                            <div>
                                <Field
                                    name="middle_name"
                                    placeholder={Strings.middle_name_acc_pd}
                                    className={styles.ProfileFormField}
                                    type="text"
                                    autoComplete="off"
                                    id="name"
                                    component={customInput}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>Last Name</div>
                            <div>
                                <Field
                                    name="last_name"
                                    placeholder={Strings.last_name_acc_pd}
                                    className={styles.ProfileFormField}
                                    type="text"
                                    id="last_name"
                                    autoComplete="off"
                                    component={customInput}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                        <div className="col-3">
                            <div className={styles.ProfileLabelV2}>Date of Birth</div>
                            <div>
                                <Field
                                    name="date_of_birth"
                                    id="date_of_birth"
                                    disabledDate={this.disabledDate}
                                    component={CustomDatepicker}
                                    className="profile-v2-date-picker"
                                    dropdownClassName="cs-datepicker-dropdown"
                                    disabled={!this.state.hasEditPermission}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>Gender</div>
                            <div>
                                <Field
                                    name="gender"
                                    type="text"
                                    id="gender"
                                    options={this.gender.map((gen) => ({
                                        label: gen,
                                        value: gen,
                                    }))}
                                    component={CustomSingleSelect}
                                    styles={colourStyles}
                                    otherProps={{
                                        components: { dropdownIndicator: <components.DownChevron /> },
                                        isDisabled: !this.state.hasEditPermission
                                    }} />
                            </div>
                        </div>

                        <div className="col-3 border-right">
                            <div className="sf-form">
                                <div className={styles.ProfileLabelV2}>Mobile Number</div>
                                <div className="co-code-mobile-no">
                                    <div className="d-flex w-100">
                                        <div style={{ flex: "0 0 70px" }}>
                                            <Field name="country_code" options={countryCodes.map(country => ({
                                                label: country.dial_code, value: country.dial_code
                                            }))} component={CustomSingleSelect} otherProps={{
                                                styles: PhoneDropdownStyle, placeholder: "",
                                                components: { DropdownIndicator: this.DropdownIndicator }
                                            }} />
                                        </div>
                                        <div style={{ flex: "1 1 auto" }}>
                                            <Field name="phone_number" type="text" id="phone" className={`${styles.InputFieldV2} ${styles.CustomPhone}`}
                                                placeholder="Mobile Number" component={customInput} />
                                        </div>
                                    </div>
                                </div>
                                {
                                    initialValues && initialValues.phone_verified === 0
                                        ? <div className="no-varify-form">
                                            <div>
                                                <Field
                                                    name="phone_code"
                                                    placeholder="Enter OTP here."
                                                    type="text"
                                                    validate={isNumber}
                                                    id="phone_code"
                                                    className={styles.ProfileFormField}
                                                    component={customInput}
                                                    disabled={!this.state.hasEditPermission} />
                                            </div>
                                            <button type="button" disabled={!this.state.hasEditPermission} className="bnt bnt-active" onClick={this.handleVerifyPhn}>Verify</button>
                                            {
                                                this.state.phnOtpErr
                                                    ? <span class="error-input">This is a required field</span>
                                                    : ''
                                            }
                                            <Link className="re-send-bnt" onClick={(val) => this.resendOtpPhn(val = 'PHONE')}>Resend OTP</Link>
                                        </div>
                                        : ''
                                }
                            </div>
                        </div>
                        {roleSlug !== "STAFF" ?
                            < div className="col-3 border-right">
                                <div className={styles.ProfileLabelV2}>Phone Number</div>
                                <div>
                                    <Field
                                        name="contact_number"
                                        type="text"
                                        id="contact_number"
                                        className={styles.ProfileFormField}
                                        component={customInput}
                                        disabled={!this.state.hasEditPermission} />
                                </div>
                            </div> :
                            <div></div>
                        }

                        <div className="col-3">
                            <div className={styles.ProfileLabelV2}>Primary Email</div>
                            <div>
                                <Field
                                    name="email_address"
                                    placeholder={Strings.email_address_acc_pd}
                                    type="text"
                                    id="email_address"
                                    className={styles.ProfileFormField}
                                    component={customInput}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                            {initialValues && initialValues.email_verified === 0 ?
                                <div className="no-varify-form">
                                    <div>
                                        <Field
                                            name="email_code"
                                            placeholder="Enter OTP here."
                                            type="text"
                                            id="email_code"
                                            validate={isNumber}
                                            className={styles.ProfileFormField}
                                            component={customInput}
                                            disabled={!this.state.hasEditPermission} />
                                    </div>
                                    <button disabled={!this.state.hasEditPermission} type="button" className="bnt bnt-active" onClick={this.handleVerifyEmail}>Verify</button>
                                    {this.state.emailOtpErr ?
                                        <span class="error-input">This is a required field</span>
                                        :
                                        ''
                                    }
                                    <Link className="re-send-bnt" onClick={(val) => this.resendOtpEmail(val = 'EMAIL')}>Resend OTP</Link>
                                </div>
                                :
                                ''
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 border-right">
                            <div className={styles.ProfileLabelV2}>Student USI</div>
                            <div>
                                <Field
                                    name="student_usi"
                                    type="text"
                                    placeholder={Strings.student_usi}
                                    id="student_usi"
                                    component={customInput}
                                    className={styles.ProfileFormField}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                        <div className="col-3 border-right">
                            <div className={styles.ProfileLabelV2}>Visa Number</div>
                            <div>
                                <Field
                                    name="visa_number"
                                    type="text"
                                    placeholder={Strings.visa_number}
                                    id="visa_number"
                                    component={customInput}
                                    className={styles.ProfileFormField}
                                    disabled={!this.state.hasEditPermission} />
                            </div>
                        </div>
                    </div>
                    <div className="mt-2">
                        <button type="submit" className={styles.BtnSaveTab} disabled={!this.props.isDirty || !this.state.hasEditPermission}>
                            Save
                        </button>
                    </div>
                </div>
            </form >
        );
    }
}

const mapStateToProps = (state) => {
    let value = {}
    if (state.profileManagement && state.profileManagement.profile) {
        for (let item of state.profileManagement.profile) {
            if (item.profile_pic) {
                value = {
                    id: item.id, name: item.name ? item.name : '', last_name: item.last_name ? item.last_name : '',
                    date_of_birth: item.date_of_birth && item.date_of_birth !== "null" ? moment.utc(item.date_of_birth).format("YYYY-MM-DD") : null,
                    country_code: item.country_code && item.country_code.value ? item.country_code.value : null, phone_number: item.phone_number, contact_number: item.contact_number ? item.contact_number : '',
                    email_address: item.email_address, student_usi: item.student_usi ? item.student_usi : '',
                    zone: item.zone, profile_pic: item.profile_pic,
                    visa_number: item.visa_number ? item.visa_number : '', visa_doc: item.visa_doc,
                    passport_number: item.passport_number,
                    middle_name: item.middle_name ? item.middle_name : '',
                    gender: item.gender && item.gender !== "null" ? { label: item.gender, value: item.gender } : null,
                    country_code: item.country_code && item.country_code !== "null" ? { label: item.country_code, value: item.country_code } : null,
                    phone_verified: item.phone_verified,
                    email_verified: item.email_verified,
                }

            } else {
                value = {
                    id: item.id, name: item.name ? item.name : '', last_name: item.last_name ? item.last_name : '',
                    date_of_birth: item.date_of_birth && item.date_of_birth !== "null" ? moment.utc(item.date_of_birth).format("YYYY-MM-DD") : null,
                    country_code: item.country_code && item.country_code.value ? item.country_code.value : null, phone_number: item.phone_number, contact_number: item.contact_number ? item.contact_number : '',
                    email_address: item.email_address, student_usi: item.student_usi ? item.student_usi : '',
                    zone: item.zone, visa_number: item.visa_number ? item.visa_number : '',
                    visa_doc: item.visa_doc, passport_number: item.passport_number,
                    middle_name: item.middle_name ? item.middle_name : '',
                    gender: item.gender && item.gender !== "null" ? { label: item.gender, value: item.gender } : null,
                    country_code: item.country_code && item.country_code !== "null" ? { label: item.country_code, value: item.country_code } : null,
                    phone_verified: item.phone_verified,
                    email_verified: item.email_verified,
                }
            }
        }
    }

    for (let key in value) {
        if (value[key] === "null") {
            value[key] = null;
        }
    }

    let initialValues = {
        ...value,
    }
    return {
        formValues: state.form && state.form.PesonalDetailsForm &&
            state.form.PesonalDetailsForm.values ? state.form.PesonalDetailsForm.values : {},
        isDirty: isDirty('PesonalDetailsForm')(state),
        profileComplete: state.profileManagement && state.profileManagement.profileComplete,
        profile: state.profileManagement && state.profileManagement.profile,
        initialValues: initialValues,
    }
}

const mapDispatchToprops = dispatch => {
    return {
        action: bindActionCreators(actions, dispatch),
    }
}

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToprops),
    reduxForm({
        form: 'PesonalDetailsForm', validate: personalDetailsForm, enableReinitialize: true,
        onSubmitFail: (errors, dispatch, sub, props) => {
            handleFocus(errors, "#");
        }
    })
)(PesonalDetailsForm)